var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcHeaderMap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.9289 9.03079C16.629 8.33875 16.1705 7.71843 15.5865 7.21466C15.0024 6.71089 14.3074 6.33626 13.5517 6.11785C12.7961 5.89945 11.9985 5.84272 11.2169 5.95178C10.4352 6.06084 9.68889 6.33295 9.03188 6.74845C8.37488 7.16394 7.8236 7.71245 7.4179 8.3543C7.01219 8.99616 6.7622 9.71533 6.686 10.4598C6.60979 11.2043 6.70927 11.9556 6.97725 12.6592C7.24523 13.3629 7.67501 14.0014 8.23552 14.5286L12.0044 18.1021L15.7733 14.5286C16.5215 13.8248 17.0311 12.9259 17.237 11.9466C17.4428 10.9673 17.3355 9.95209 16.9289 9.03079ZM13.6814 12.5482C13.2939 12.9155 12.7838 13.1443 12.2381 13.1954C11.6924 13.2466 11.1449 13.1171 10.6887 12.829C10.2326 12.5408 9.89607 12.1119 9.73655 11.6152C9.57703 11.1185 9.60435 10.5848 9.81387 10.105C10.0234 9.62529 10.4021 9.22915 10.8856 8.98411C11.369 8.73907 11.9272 8.66029 12.4652 8.7612C13.0031 8.86211 13.4874 9.13646 13.8356 9.5375C14.1838 9.93855 14.3744 10.4415 14.3748 10.9606C14.375 11.2554 14.3139 11.5473 14.195 11.8197C14.076 12.0921 13.9015 12.3397 13.6814 12.5482Z",
    fill: "#FEFEFE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcHeaderMap);
export default __webpack_public_path__ + "static/media/ic_header_map.0d5512b476d58e586d19cdc7008a6802.svg";
export { ForwardRef as ReactComponent };